// src/components/Footer.jsx
import React from "react";

export default function Footer() {
  return (
    <footer className="home-footer">
      <div className="home-footer-content">
        <div className="home-footer-brand">
          <h3>
            Emilia<br />
            <span>NAIL STUDIO</span>
          </h3>
          <p>Embelleciendo tus manos con pasión y profesionalismo</p>
        </div>

        <div className="home-footer-links">
          <div className="home-footer-column">
            <h4>Navegación</h4>
            <a href="#nosotros">Nosotros</a>
            <a href="#servicios">Servicios</a>
            <a href="#contacto">Contacto</a>
          </div>

          <div className="home-footer-column">
            <h4>Contacto</h4>
            <a href="https://wa.me/51932587523" target="_blank" rel="noopener noreferrer">WhatsApp</a>
            <a href="https://www.instagram.com/emilia_nailstudio?igsh=NzMxdXZvNzdxbGtu" target="_blank" rel="noopener noreferrer">Instagram</a>
            <a href="mailto:contacto@valentinanails.com">Email</a>
          </div>

          <div className="home-footer-column">
            <h4>Información</h4>
            <a href="#">Políticas de Privacidad</a>
            <a href="#">Términos y Condiciones</a>
            <a href="#">Preguntas Frecuentes</a>
          </div>
        </div>
      </div>

      <div className="home-footer-bottom">
        <p>© 2025 Emilia Nail Studio. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
}
